import { render } from "./userCenterMenu.vue?vue&type=template&id=1c109de0&scoped=true"
import script from "./userCenterMenu.vue?vue&type=script&lang=js"
export * from "./userCenterMenu.vue?vue&type=script&lang=js"

import "./userCenterMenu.vue?vue&type=style&index=0&id=1c109de0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c109de0"]])

export default __exports__